import apiClient from './client';

// Doctor 健康分（P5）：接口失败时调用方诚实降级（隐藏徽章/面板），不阻塞页面

export type DoctorGrade = 'healthy' | 'attention' | 'critical';
export type DoctorSeverity = 'error' | 'warning';

export interface DoctorIssue {
  id: string;
  severity: DoctorSeverity;
  deduction: number;
  title: string;
  description: string;
  suggestion: string;
  /** 配置中心维度锚点：persona / skills / knowledge / llm / workflows / deployments / runtime */
  anchor: string;
}

/** 能力真实探测状态（B7）：ok / broken / timeout / error / skipped */
export type ProbeStatus = 'ok' | 'broken' | 'timeout' | 'error' | 'skipped';

export interface CapabilityProbe {
  /** 探测项名：llm / mcp / runtime / embedding */
  name: string;
  /** 人话展示名：大模型通道 / MCP 工具 / 运行时镜像 / 知识库向量化 */
  label: string;
  status: ProbeStatus;
  /** 人话详情 */
  detail: string;
  /** 修复处方（人话中文）；ok 状态通常为空 */
  prescription: string;
}

export interface DoctorReport {
  agent_id: string;
  score: number;
  grade: DoctorGrade;
  issues: DoctorIssue[];
  checked_at: string;
  /** 能力真实探测结果（B7）；旧后端无此字段，前端据此隐藏能力探测区块 */
  probes?: CapabilityProbe[];
}

export const DOCTOR_GRADE_LABELS: Record<DoctorGrade, string> = {
  healthy: '健康',
  attention: '需关注',
  critical: '危重',
};

export async function getAgentDoctor(agentId: string): Promise<DoctorReport> {
  const res = await apiClient.get(`/agents/${agentId}/doctor`);
  return res.data;
}
